import React from 'react';
import { Loader } from '../../components/ui/Loader/Loader';
import { useCosts } from '../../hooks/useCosts';
import { useShouldVerifyAccount } from '../HomePage/hooks/useShouldVerifyAccount';
import { BookingProductSelectionPage } from './BookingProductSelectionPage';

export const BookingProductSelectionPageContainer = () => {
  const { isLoadingCosts, costs } = useCosts();

  // ensures user has mail and phone number verified if registration is stopped at intermediate step
  useShouldVerifyAccount();

  if ( isLoadingCosts) {
    return <Loader fullscreen size='large' />;
  }

  return (
    <BookingProductSelectionPage
      patient={undefined}
      phoneNumber={''}
      preSelection={true}
      email={''}
      costs={costs!}
    />
  );
};
